import React,{useState} from "react";
import PortalDataTable from "../../../components/PortalDataTable";
import {FiPlusCircle,FiRefreshCcw}  from 'react-icons/fi'  
import { SearchBox, Modal } from "../../../components";
import { roleColumns } from "../../../utils";
import {useGetRoles} from "../../../hooks/roles/useGet"
import CreateRole from "../../../forms/create/CreateRole";
import NetworkError from "../../../components/NetworkError";

const Roles = () => {
  const [toggleModal,setToggleModal] = useState(false)
  const {data,isLoading,isError,error}=useGetRoles();


  const handleModalToggle=()=>{
    setToggleModal(prevState=>!prevState);
}
  

if (isError && error.code === 'ERR_NETWORK') {
  return (
      <NetworkError error={error}/>
  )
}

  if(isError) return <span>Oops something happened....</span>
  return (
    <div className="w-full flex flex-col px-10">
      <div className="branch_header">
        <div className="branch_header_title_group">
          <div className="branch_header_title_main">Roles</div>
          {!isLoading&&<div className="branch_header_title_sub"> {data?.length==0?'No ':data.length} roles</div>}
        </div>
        <div className="branch_header_buttons_group">
          <div
            onClick={handleModalToggle}
            className="branch_header_buttons_right bg-[#0E86D4]"
          >
            <FiPlusCircle style={{ marginRight: "10px" }} />
            New Role
          </div>
        </div>
      </div>
      {/* <SearchBox /> */}
      <Modal title='Create Role' form={<CreateRole/>} toggleModal={toggleModal} handleToggle={handleModalToggle} />
      <PortalDataTable cols={roleColumns} loading={isLoading} rows={data} />
    </div>
  );
};

export default Roles;

